import { render, staticRenderFns } from "./DescriptionPopup.vue?vue&type=template&id=1ff2960a&scoped=true&"
import script from "./DescriptionPopup.vue?vue&type=script&lang=js&"
export * from "./DescriptionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff2960a",
  null
  
)

export default component.exports